/**
 * src/components/promos/PromoCard.js
 *
 * Tarjeta individual de promoción.
 * Props: { id, business, image, tag, discount, href }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('PromoCard', ({ id, business, image, tag, title, discount, views }) => {
    const href = `/promociones/${id}`
    const label = title || discount || 'Ver promoción'

    return h('article', { className: 'promo-card' },
        h('a', { className: 'promo-card__img-wrap', href },
            h('img', { src: image, alt: label, className: 'promo-card__img' }),
            h('span', { className: 'promo-card__tag' }, tag)
        ),
        h('div', { className: 'promo-card__body' },
            h('p', { className: 'promo-card__business' }, business),
            h('p', { className: 'promo-card__discount'  }, label),
            h('div', { style: 'display:flex;align-items:center;justify-content:space-between;margin-top:auto' },
                views ? h('span', { className: 'promo-card__views' }, `👁 ${views}`) : null,
                h('a', { className: 'promo-card__cta', href }, 'Ver promoción →')
            )
        )
    )
})
